<template>
    <div>
        <div class="block is-flex container is-widescreen">
            <div class="title m-sm">
                Development Tasks
            </div>
            <b-autocomplete
                v-model="filterDevText"
                placeholder="Select Developer"
                :open-on-focus="true"
                :data="filteredDevArray"
                field="attributes.email"
                @select="setDeveloper"
                @input="getTickets(1)"
                :clearable="true"
                ref="devs"
                class="m-sm"
            >
            </b-autocomplete>
            <b-autocomplete
                v-model="filterAppText"
                placeholder="Select App"
                :open-on-focus="true"
                :data="filteredAppArray"
                field="text"
                @select="setApp"
                @input="getTickets(1)"
                :clearable="true"
                ref="apps"
                class="m-sm"
            >
            </b-autocomplete>
        </div>
        <div class="box">
            <div class="columns">
                <div class="column">
                    <div class="block card">
                        <div class="card-header">
                            <div class="card-header-title has-text-light has-background-primary">
                                LOG
                            </div>
                        </div>
                    </div>
                    <draggable class="list-group" :list="sortable.queued" @change="listUpdate($event,'queued')" group="tickets">
                        <card v-for="(task,key) in sortable.queued" :key="key" :task="task" color="primary"/>
                    </draggable>
                </div>
                <div class="column">
                    <div class="block card">
                        <div class="card-header">
                            <div class="card-header-title has-text-light has-background-info">
                                DEVELOPMENT
                            </div>
                        </div>
                    </div>
                    <draggable class="list-group" :list="sortable.developing" @change="listUpdate($event,'developing')" group="tickets">
                        <card v-for="(task,key) in sortable.developing" :key="key" :task="task" color="info"/>
                    </draggable>
                </div>
                <div class="column">
                    <div class="block card">
                        <div class="card-header">
                            <div class="card-header-title has-text-light has-background-dark">
                                READY FOR QA TESTING
                            </div>
                        </div>
                    </div>
                    <draggable class="list-group" :list="sortable.ready_for_QA_testing" @change="listUpdate($event,'ready for QA testing')" group="tickets">
                        <card v-for="(task,key) in sortable.ready_for_QA_testing" :key="key" :task="task" color="dark"/>
                    </draggable>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import _ from 'lodash'
import draggable from 'vuedraggable'
import card from '../includes/card';

export default {
    components: {
        draggable,
        card
    },
    data() {
        return {
            filterAppText:'',
            filterDevText:'',
            apps:[],
            appSelected: null,
            devSelected: null,
            developers: [],
            tickets:[],
            statuses: [
                "queued", 
                "developing", 
                "ready for QA testing", 
            ],
            sortable:{
                queued:[],
                developing:[],
                ready_for_QA_testing:[],
            }
        }
    },
    watch: {
        filterAppText(value) {
            if(value===''){
                this.appSelected = null
                this.getTickets(1)
            }
        },
        filterDevText(value) {
            if(value===''){
                this.devSelected = null
                this.getTickets(1)
            }
        },
    },
    computed: {
        loading: {
            get() {
                return this.$store.state.loading;
            },
            set(value) {
                this.$store.commit("SET_LOADING", value);
            }
        },
        filteredAppArray(){
            if(this.appSelected){
                return this.apps.filter((app) => {
                    return (app.text.toString().toLowerCase().indexOf(this.appSelected.toLowerCase())) >= 0
                })
            }
            return this.apps.length ? this.apps : []
        },
        filteredDevArray(){
            if(this.filterDevText){
                return this.developers.filter((developer) => {
                    return (developer.attributes.email.toString().toLowerCase().indexOf(this.filterDevText.toLowerCase())) >= 0
                })
            }
            return this.developers.length ? this.developers : []
        },
        referrer() {
            return document.referrer
        },
    },
    async mounted() {
        this.loading = true
        await this.getAppList()
        await this.getDevelopers()
        await this.getTickets(1)
        this.loading = false
    },
    methods: {
        async getTickets(page){
            this.tableloading = true;
            let params = this.getParams(page);
            Vue.$ticketService.ticketList(params).then(async(response) => {
                this.tickets = response.data;
                let keys = Object.keys(this.sortable);
                await keys.forEach((key)=>{
                    let status = key
                    this.sortable[status] = this.tickets.filter((value)=>{
                        return value.attributes.status.replace(/\s+/g,'_',)===status
                    })
                })
            });
        },
        getParams(page) {
            let params = `?page=${page ? page : 1}`;

            let status = "";
            this.statuses.forEach((val, index) => {
                status = status + `&status[${index}]=${val}`;
            });
            params = params + status;

            if(this.appSelected) {
                params+=`&app_id=${this.appSelected}`;
            }

            if(this.devSelected) {
                params+=`&developer_id=${this.devSelected.id}`
            }

            return params;
        },
        getAppList() {
            this.apps = this.$store.getters.getApps
            this.loading = false;
        },
        setApp(value){
            if(value){
                this.appSelected = value.text
            }
        },
        getDevelopers() {
            this.loading = true
            Vue.$userService.userList('?roles=developer').then((response)=>{
                this.developers = response.data
                if(this.isRole('developer')){
                    this.loading = false
                    this.$refs.devs.setSelected(_.find(this.developers,{id:this.$store.state.user.id}))
                }
            })
        },
        setDeveloper(value){
            if(value){
                this.devSelected = value
            }
        },
        listUpdate(value,type) {
            let status = type;
            if(value.added){
                let ticket = value.added.element.attributes
                Vue.$ticketService.updateTicket(value.added.element.id,{
                    type: ticket.type,
                    priority:ticket.priority,
                    details:ticket.details,
                    app_id:ticket.app_id,
                    status: status
                }).then(()=>{
                    this.toast = this.$buefy.toast.open({
                        message: 'Task saved!',
                        type: 'is-success'
                    })
                })
            }
        },
    }
}
</script>
<style scoped>
    .card, .card-header-title{
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .card, .card-content{
        border: none !important;
        box-shadow: none !important;
    }
    .list-group {
        min-height: 40px;
    }
</style>